import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { AxiosRequest } from "../../Handlers/AxiosHandler";

export class CurrencyPricesVM extends InterActive{
    private data?:{id:string , account:string, arabic_currency_name:string , english_currency_name:string , price:string ,status:'active'|'inActive'}[]
    private newData:{id:string , account:string, arabic_currency_name:string , english_currency_name:string , price:string ,status:'active'|'inActive'} = {id:'' , account:'', arabic_currency_name:'' , english_currency_name:'' , price:'' ,status:'active'}

    public get Data():{id:string, account:string , arabic_currency_name:string , english_currency_name:string , price:string ,status:'active'|'inActive'}[]|undefined{ return this.data }
    public get NewData():{id:string , account:string, arabic_currency_name:string , english_currency_name:string , price:string ,status:'active'|'inActive'}{ return this.newData }

    public set Account(value:string){ this.newData.account = value; this.update() }
    public set ArabicCurrencyName(value:string ){ this.newData.arabic_currency_name = value; this.update() }
    public set EnglishCurrencyName(value:string) { this.newData.english_currency_name = value; this.update() }
    public set Price(value:string){ this.newData.price = GeneralMethods.removeNonPositiveFloatNumeric(value); this.update()}

    private _status : 'active'|'inActive' = 'active';
    public get status() : 'active'|'inActive' {
        return this._status;
    }
    public set status(v : 'active'|'inActive') {
        this._status = v;
        this.update()
    }
    

    public changePrice(id:string , newValue:string){
        var value = GeneralMethods.removeNonPositiveFloatNumeric(newValue)
        this.data = this.data?.map(i=>i.id==id?({...i, price:value.toString() }):(i))
        this.update()
    }

    public changeAccount(id:string , newValue:string){
        this.data = this.data?.map(i=>i.id==id?({...i, account:newValue }):(i))
        this.update()
    }

    public changeArabicName(id:string , newValue:string){
        this.data = this.data?.map(i=>i.id==id?({...i, arabic_currency_name:newValue }):(i))
        this.update()
    }

    public changeEnglishName(id:string , newValue:string){
        this.data = this.data?.map(i=>i.id==id?({...i, english_currency_name:newValue }):(i))
        this.update()
    }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getCurrences()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = response.data.data
                                this.update()
                            }else Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }else  Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{  Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
            }
        )
    }

    public sendNew(data:{id:string , account:string, arabic_currency_name:string , english_currency_name:string , price:string}){
        this.loading(
            async()=>{
                try{
                    if(data.account.length == 0){  Notify({type:'danger' , title:'بيانات غير صالحة'  , body:'برجاء ادخال اسم الحساب'});return  }
                    if(data.arabic_currency_name.length == 0){  Notify({type:'danger' , title:'بيانات غير صالحة'  , body:'برجاء ادخال اسم العملة'});return  }
                    if(data.english_currency_name.length == 0){  Notify({type:'danger' , title:'بيانات غير صالحة'  , body:'برجاء ادخال رمز العملة'});return  }
                    if(data.price.length == 0){  Notify({type:'danger' , title:'بيانات غير صالحة'  , body:'برجاء ادخال سعر العملة'});return  }

                    const response = await ApiRequest.changeCurrenciesPrices(data)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                Notify({type:'success' , title:'تمت العملية بنجاح', body:'تمت العملية بنجاح'})
                            }else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية', body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }                   
                }catch{ Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
            }
        )
    }

    public pushItem(data:{id:string , account:string, arabic_currency_name:string , english_currency_name:string , price:string ,status:'active'|'inActive'}){
        if(this.data)this.data.push(data)
        this.newData = { id:'' , account:'' , arabic_currency_name:'' , english_currency_name:'' , price:'' ,status:'active'}
         this.update()
    }

    public changeState(id:string,status:'active'|'inActive'){
        this.loading(async()=>{
            try{
                let response = await AxiosRequest.statusPost<{id:string, status:'active'|'inActive'}>('changeCurrencyState',{id:id , status:status})
                if(response){
                    if(response.status === HttpStatusCode.Ok){
                        if(!response.data.status)
                        Notify({type:'danger' , title:'خطأ'  , body:response.data.messege})
                    }else Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
            catch{
                Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
            try{
                const response = await ApiRequest.getCurrences()
                if(response){
                    if(response.status === HttpStatusCode.Ok){
                        if(response.data.status){
                            this.data = response.data.data
                            
                        }else Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }else  Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }catch{  Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
            this.update()
        })
    }

}